// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { EntityTagHeaderValue, IEntityTagHeaderValue } from "./Microsoft.Net.Http.Headers.EntityTagHeaderValue.gen";

export interface IFileContentResult {
	fileContents: number[];

	contentType: string | undefined;

	fileDownloadName: string | undefined;

	lastModified: string | undefined;

	entityTag: IEntityTagHeaderValue | undefined;

	enableRangeProcessing: boolean;

	$type?: string | undefined;
}
export class FileContentResult {
	constructor(data?: IFileContentResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.lastModified) { this.lastModified = new Date(data.lastModified); }
		if (data.entityTag) { this.entityTag = new EntityTagHeaderValue(data.entityTag); }
	}

	fileContents: number[] = [];

	contentType: string | undefined;

	fileDownloadName: string | undefined;

	lastModified: Date | undefined;

	entityTag: EntityTagHeaderValue | undefined;

	enableRangeProcessing: boolean = false;

	static $type: string = "Microsoft.AspNetCore.Mvc.FileContentResult, ";
	$type?: string | undefined = FileContentResult.$type;
}

